import React, { Suspense } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import { FillContentLoader } from '@shared/components/Loader';
import { DeviceDashboard } from './dashboard/DeviceDashboard';
import { CaptivePortalPage } from './routes/captive';

// Auth routes
const Activate = React.lazy(() => import('./routes/activate/index'));
const ActivateDevice = React.lazy(() => import('./routes/activate/[devicePublicId]'));

// Lazy-load route components
const Home = React.lazy(() => import('./routes/index'));

const authRoutes = new Set(['/']);

export default function App() {
  const location = useLocation();

  return (
    <DeviceDashboard noAuth={!authRoutes.has(location.pathname)}>
      <Content />
    </DeviceDashboard>
  );
}

function Content() {
  return (
    <Suspense fallback={<FillContentLoader />}>
      <Routes>
        {/* Auth Pages */}
        <Route path="/activate" element={<Activate />} />
        <Route path="/admin" element={<Activate />} />
        <Route path="/activate/:devicePublicId" element={<ActivateDevice />} />
        <Route path="/captive" element={<CaptivePortalPage />} />
        <Route path="/" element={<Home />} />
      </Routes>
    </Suspense>
  );
}
